const Backbone = require('lib/backbone')
const _ = require('lib/underscore')
const $ = require('lib/jquery')
const Modernizr = require('vendor/modernizr')
const radio = require('lib/radio')
const log = require('log').create('viewport')


const viewport_sizes = ['small', 'medium', 'large']
const viewport_classnames = viewport_sizes.map(size => `viewport-${size}`)

const Viewport = Backbone.Model.extend({

    defaults: {
        size: '',
        tiny: null,
        small: null,
        medium: null,
        large: null,
    },

    initialize(attributes, options) {
        Backbone.Model.prototype.initialize.apply(this, arguments)

        this.setViewportClass = _.debounce(this.setViewportClass, 100)

        this.listenTo(radio.viewport, 'window:resize window:orientationchange', this.checkViewportSize)

        this.on('change:size', this.onChangeSize)
        this.on('change:small', this.onChangeSmall)
        this.on('change:medium', this.onChangeMedium)
        this.on('change:large', this.onChangeLarge)
        // this.on('all', this.onEvent);

        this.initializeEvents()
        this.checkViewportSize()
    },

    onEvent(name) {
        log('viewport event:', name)
    },

    initializeEvents() {
        // throttled events for window events, e.g. resize and scroll
        const onResize = _.debounce(() => {
            radio.viewport.trigger('window:resize')
        }, 100)
        const onScroll = _.debounce(() => {
            radio.viewport.trigger('window:scroll')
        }, 500)
        // wrapping orientationchange so it can be used along with window:resize
        const onOrientationChange = () => {
            radio.viewport.trigger('window:orientationchange')
        }

        window.addEventListener('resize', onResize)
        window.addEventListener('scroll', onScroll)
        window.addEventListener('orientationchange', onOrientationChange)

        this.on('before:destroy', () => {
            window.removeEventListener('resize', onResize)
            window.removeEventListener('scroll', onScroll)
            window.removeEventListener('orientationchange', onOrientationChange)
        })
    },

    checkViewportSize() {
        let size
        const values = {}

        // small/medium/large sizes are mutually-exclusive

        if (Modernizr.mq('only screen and (max-width: 640px)')) {
            size = 'small'

        } else if (Modernizr.mq('only screen and (min-width: 641px) and (max-width: 1024px)')) {
            size = 'medium'

        } else if (Modernizr.mq('only screen and (min-width: 1025px)')) {
            size = 'large'
        }

        values.size = size

        // set all viewport sizes to false
        viewport_sizes.forEach(key => {
            values[key] = false
        })

        // set current viewport size to true
        values[size] = true

        // tiny is a special case, so it's possible to be small & tiny or small & not tiny
        values.tiny = Modernizr.mq('only screen and (max-width: 320px)')

        this.set(values)

    },

    onChangeSize() {
        const size = this.get('size')
        this.setViewportClass(size)
    },

    setViewportClass(size) {
        const classname = `viewport-${size}`
        if (! $.html.hasClass(classname)) {
            // remove other viewport classnames, add new one
            $.html.removeClass(viewport_classnames.join(' ')).addClass(classname)

            // remove the not- classname for the new size
            $.html.removeClass(`viewport-not-${size}`)

            // add the not- classnames for the other sizes
            const not_classnames = (
                viewport_sizes
                    .filter(viewport_size => viewport_size !== size)
                    .map(viewport_size => `viewport-not-${viewport_size}`)
            )
            $.html.addClass(not_classnames.join(' '))
        }
    },

    onChangeSmall() {
        this.triggerSizeChangeEvent('small')
    },
    onChangeMedium() {
        this.triggerSizeChangeEvent('medium')
    },
    onChangeLarge() {
        this.triggerSizeChangeEvent('large')
    },
    triggerSizeChangeEvent(size) {
        const bool = this.is(size)
        if (bool) {
            radio.viewport.trigger(`viewport:${size}`)
        } else {
            radio.viewport.trigger(`viewport:not:${size}`)
        }
    },

    // .is performs an explicit true/false check on the given key
    // e.g. Viewer.is('admin') is the same as doing: Viewer.get('admin') === true
    is() {
        const value = this.get.apply(this, arguments)
        return (value === true)
    },
    isNot() {
        const value = this.get.apply(this, arguments)
        return (value !== true)
    },

    // overriding model.destroy cuz we don't need typical model.destroy behavior
    // since this model is never part of a collection
    // we just want to remove our listeners and stuff
    destroy() {
        this.trigger('before:destroy')
        this.stopListening()
    },

})

module.exports = Viewport
